import PropTypes from 'prop-types';
import React from 'react';

import { OSLO_GRAY } from '@wetransfer/transfer/constant/colors';

const Folder = ({ width, height }) => (
  <svg
    viewBox="0 0 9 7"
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0 6.14285714V.85714286C0 .38375593.38375593 0 .85714286 0h2.26447876c1.33783784 0 .74324324 1.23673511 2.08108108 1.23673511h2.94015444C8.61624407 1.23673511 9 1.62049104 9 2.09387797v4.04897917C9 6.61624407 8.61624407 7 8.14285714 7H.85714286C.38375593 7 0 6.61624407 0 6.14285714z"
      fill={OSLO_GRAY}
    />
  </svg>
);

Folder.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Folder.defaultProps = {
  width: 9,
  height: 7,
};

export default Folder;
